import React from 'react';
import { Box } from '@mui/material';
import PricingSectionNew from '../components/PricingSectionNew';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const PricingPageNew = () => {
  return (
    <Box>
      <Navbar />
      <Box sx={{ pt: { xs: 8, md: 10 } }}>
        <PricingSectionNew />
      </Box>
      <Footer />
    </Box>
  );
};

export default PricingPageNew;
